import { createAction, props } from '@ngrx/store';
import { Authenticate, UserModel, Token } from '@kanzi-apes/kanzi-models';

export const initAuth = createAction('[Auth Page] Init');

export const login = createAction(
  '[Auth/API] Login',
  props<{ loginForm: Authenticate }>()
);

export const logout = createAction('[Auth/API] Logout');

export const loginSuccess = createAction(
  '[Auth/API] Login Success',
  props<{ token: Token }>()
);

export const loginFailure = createAction(
  '[Auth/API] Login Failure',
  props<{ error: any }>()
);

export const loginRedirect = createAction('[Auth/API] Login Redirect');

export const userProfileLoad = createAction('[Auth/API] User Profile Load');

export const userProfileSuccess = createAction(
  '[Auth/API] User Profile Success Load',
  props<{ user: UserModel }>()
);

export const userLoginFailureToken = createAction('[Auth/API] No Token');
